import React, { useState } from 'react'

import { Challenge } from '../../../types'
import { translateStatus } from '../../../utilFunctions/transformFunc'
import { ChallengeCardBtn } from '../../buttons'
import {
  PreviewBadge,
  PreviewCard,
  PreviewHashtags,
  PreviewImage,
  PreviewMeta,
  PreviewTitle,
  TitleContainer,
} from '../ChaPreview'
import { ChallengeCard } from '../styles'

const ChallengeCards = ({ ch }: { ch: Challenge }) => {
  const [instructions, setInstructions] = useState<boolean>(false)
  const badgeLabel = translateStatus(ch.status)
  const formatRange = () => {
    if (!ch.startDate && !ch.endDate) return ''
    const fmt = (d: string) => (d ? d.split('-').join('.') : '')
    return `${fmt(ch.startDate)}  –  ${fmt(ch.endDate)}`
  }

  // const icon = ch.category === 'Reels' ? <TbPhotoVideo /> : <FiCamera />
  return (
    <>
      <ChallengeCard>
        <PreviewCard>
          <PreviewImage
            src={ch.image || 'assets/profile.png'}
            alt={ch.altText}
          />

          <PreviewBadge $status={ch.status}>{badgeLabel}</PreviewBadge>
          <TitleContainer>
            {/* <div>{icon}</div> */}
            <div style={{ width: '100%' }}>
              <PreviewTitle>{ch.title || 'Título del desafío'}</PreviewTitle>
              <PreviewMeta>{formatRange()}</PreviewMeta>
            </div>
          </TitleContainer>

          <PreviewMeta>
            Descripción: <br />
            {ch.description}
          </PreviewMeta>
          <PreviewHashtags>
            hashtags: <br /> {ch.hashtags.map((tag) => `#${tag}`).join(' ')}
          </PreviewHashtags>
          {instructions && (
            <PreviewMeta>
              Instrucciones: <br />
              {ch.instructions}
            </PreviewMeta>
          )}
          <ChallengeCardBtn
            challenge={ch}
            onClickFn={() => setInstructions(!instructions)}
          />
        </PreviewCard>
      </ChallengeCard>
    </>
  )
}

export default ChallengeCards
